import { Application } from '@hotwired/stimulus';

import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

import ENVIRONMENT from './scripts/environment';
import tarjet_form from './scripts/float_contact';
import tarjet_button_slider_df from './scripts/difference';
import tarjet_button_slider_df_mobile from './scripts/difference_mobile';
import tarjet_button_slider from './scripts/contact';
import tarjet_tab_accordion from './scripts/accordion';
import b_accordion_init from './scripts/b-accordion.js';
import filter_faqs from './scripts/faqs_filter';
import tarjet_tab_locations from './scripts/locations';
import locations_filter_country from './scripts/locations_filter';
import NightsafeScript from './scripts/nightsafe_script.js';
import switch_page from './scripts/switch_page';
import switch_page_tabs from './scripts/switch_page_tabs';
import goto_careers from './scripts/goto_careers';
import collapsible_card from './scripts/collapsible_card';
import display_content from './scripts/dropdown';
import goto_search from './scripts/goto_search';
import search_top from './scripts/search_top';
/* import load_content from './scripts/load_content';
import load_content_press from './scripts/load_content_press';
import load_content_news from './scripts/load_content_news';
import load_content_cases from './scripts/load_content_cases'; */
/*import owl_carousel from './cdns/owl_carousel';
import jquery from './cdns/jquery';*/
import alignIndustriesCards from "./scripts/alignIndustries";
import parseDot from "./scripts/parseDot";
import preventFormMultipleSubmitting from "./scripts/preventFormMultipleSubmitting";
import bannerAnnouncement from "./scripts/bannerAnnouncement";
import readOnlyField from "./scripts/readOnlyField";
import triggerAnalyticsGoal from "./scripts/tracking/registerGoal";

import owl_case_studies from './scripts/owl_carousels/owl_case_studies';
import owl_card_slider from './scripts/owl_carousels/owl_card_slider';
import owl_carousel from './scripts/owl_carousels/owl_carousel';
import owl_difference_comments from './scripts/owl_carousels/owl_difference_comments';
import difference_wide_cards from './scripts/difference_wide_cards';
import initHeaderSearch from './scripts/header_search';
import owl_slider_container from './scripts/owl_carousels/owl_slider_container';

// Stimulus controller auto-registration
const context = require.context('./scripts/controllers', false, /\.(js|ts)$/);
const controllers = context.keys()
  .map((key) => {
    const identifier = (key.match(/^(?:\.\/)?(.+)(?:\..+?)$/) || [])[1];
    const module = context(key);
    const controllerConstructor = module?.create?.() || module?.default;
    if (identifier && typeof controllerConstructor === 'function') {
      return { identifier, controllerConstructor };
    }
  })
  .filter(Boolean);

// Register and load controllers
requestAnimationFrame(() => {
  const application = Application.start();
  application.load(controllers);
});

/* Static */
import "./static/modal-icon-check.png";
import "./static/not_image.png";
import "./static/img_falcons.png";
import "./static/report_1.png";
import "./static/report_2.png";
import "./static/report_3.png";
import "./static/img_customer_service.png";
import "./static/img_valiuablers_goods.png";
import "./static/img_cash_24_7.png";
import "./static/img_llomis_pay.png";
import "./static/logo.png";
import "./static/home_slider1.png";
import "./static/home_slider2.png";
import "./static/home_slider3.png"; 
import "./static/img_cash_in_transit.png";
import "./static/why_cash_transit_1.png";
import "./static/why_cash_transit_2.png";
import "./static/why_cash_transit_3.png";
import "./static/head_cash_in_t.png";
import "./static/more_info.png";
import "./static/Taco-Bell-logo.png";
import "./static/KeyBank-logo.png";
import "./static/img_valiuablers_goods.png";
import "./static/international_transport.png";
import "./static/image-atm-services-main-v1-960x540-380285077@2x.png";
import "./static/image-cash-exchange-service-main-v3-960x540.png";
import "./static/image-financial-industry-page-main-v1-960x540.png";
import "./static/img_blog.png";
import "./static/Loomis_MI-0192.png";
import "./static/Loomis_MI-0206.png";
import "./static/Loomis2_MI-0349.png";
import "./static/050_te_loomis_2828.png";
import "./static/loomis_esq.svg";
import "./static/IMG_9868.png";
import "./static/check-to-slot-light.png";
import "./static/circle-dollar-to-slot-light.png";
import "./static/hand-holding-dollar-light.png";
import "./static/shield-check-light.png";
import "./static/money-from-bracket-light.png";
import "./static/arrow.png";
import "./static/bags-shopping-light.png";
import "./static/building-columns-light.png";
import "./static/user-shield-light.png";
import "./static/gem-light.png";
import "./static/citizens-bank-logo-1_0.png";
import "./static/logo-border-foods.png";
import "./static/sonic-automotive.png";
import "./static/WEMC-logo.png";
import "./static/gi_swpa_2c_cmyk.png";
import "./static/icon-atm-case-studies-darkblue.png";
import "./static/fmg_logo.png";
import "./static/Samsung_Pay_icon.png";
import "./static/apple-pay.png";
import "./static/CASH24-7.png";
import "./static/photo6.png";
import "./static/G_Pay_Lockup_1_.png";
import "./static/credit-card-light.png";
import "./static/link-light.png";
import "./static/handshake-light.png";
import "./static/lane_5000.png";
import "./static/lane_3000.png";
import "./static/move_5000.png";
import "./static/loomis_pay_premium.png";
import "./static/loomis_pay_medium.png";
import "./static/loomis_pay_standard.png";
import "./static/globe-light.png";
import "./static/Loomis_MI-0110.png";
import "./static/164_te_loomis-5014.png";
import "./static/Loomis2_MI-0145.png";
import "./static/_49A4081.png";
import "./static/Loomis_MI-0179.png";
import "./static/circle-check-light.png";
import "./static/Loomis_MI-0163.png";
import "./static/Loomis2_MI-0349.png";
import "./static/_49A4094.png";
import "./static/Malmgard_MI-0017.png";
import "./static/photo_6.png";
import "./static/trama_bg.png";
import "./static/trama_bg@2x.png";
import "./static/image-with-text-tile.png";
import "./static/image-with-text-tile@2x.png";
import "./static/img_contact.png";
import "./static/img_contact@2x.png";
import "./static/bank_axept.png"
import "./static/mastercard.png";
import "./static/american-express.png";
import "./static/UnionPay_logo.png";
import "./static/visa.png";
import "./static/jcb.png";
import "./static/fillter_icon.png";
import "./static/singles-case.png";
import "./static/The_LoomisDifference_Homepage.mp4";

/* Favicons */
import "./static/favicon/android-chrome-192x192.png";
import "./static/favicon/android-chrome-384x384.png";
import "./static/favicon/apple-touch-icon.png";
import "./static/favicon/browserconfig.xml";
import "./static/favicon/favicon-16x16.png";
import "./static/favicon/favicon-32x32.png";
import "./static/favicon/favicon.ico";
import "./static/favicon/mstile-150x150.png";
import "./static/favicon/safari-pinned-tab.svg";
import "./static/favicon/site.webmanifest";

/* Main */
import "./styles/main.scss";
import "./styles/slider.scss";

/* Abstracts */
import "./styles/abstracts/mixins.scss";
import "./styles/abstracts/variables.scss";
import "./styles/abstracts/_grid.scss";
import "./styles/abstracts/segments.scss";

/* Objects */
import "./styles/objects/item-icon.scss";
import "./styles/objects/buttons.scss";
import "./styles/objects/link-extend.scss";

/* Components */
import "./styles/components/modal_alert.scss";
import "./styles/components/buttons.scss";
import "./styles/components/floating_content.scss";
import "./styles/components/contact.scss";
import "./styles/components/banner.scss";
import "./styles/components/borde_transition.scss";
import "./styles/components/border-collapse.scss";
import "./styles/components/accordion.scss";
import "./styles/components/b-accordion.scss";
import "./styles/components/support_menutabs.scss";
import "./styles/components/switch_page.scss";
import "./styles/components/mobile_card_accordion.scss";
import "./styles/components/pagination.scss";
import "./styles/components/modals.scss";
import "./styles/components/modal_contact.scss";
import "./styles/components/support_pages.scss";
import "./styles/components/support_menutabs_bottom.scss";
import "./styles/components/goto_careers.scss";
import "./styles/components/sectorial_top_images.scss";
import "./styles/components/card_subcontainer.scss";
import "./styles/components/content_pages.scss";
import "./styles/components/financial_industry_solutions.scss";
import "./styles/components/related_study_case.scss";
import "./styles/components/card_loomis_difference.scss";
import "./styles/components/select_language.scss";
import "./styles/components/video-component.scss";
import "./styles/components/title-img.scss";
import "./styles/components/timeline.scss";
import "./styles/components/sustainabilities.scss";
import "./styles/components/sustainability-item.scss";
import "./styles/components/column-card-item.scss";
import "./styles/components/reports-presentations.scss";
import "./styles/components/annot.scss";
import "./styles/components/column-cards.scss";
import "./styles/components/carousel.scss";
import "./styles/components/carousel-item.scss";
import "./styles/components/investors-explore.scss";
import "./styles/components/categories.scss";
import "./styles/components/category.scss";
import "./styles/components/categories-img.scss";

/* Layout */
import "./styles/layout/footer.scss";
import "./styles/layout/header.scss";
import "./styles/layout/breadcrumbs.scss";

/*cdns
import "/styles/cdns/owl_theme.scss";
import "/styles/cdns/owl_carousel.scss";*/


/* Pages */
import "./styles/pages/home/industries.scss";
import "./styles/pages/home/difference.scss";
import "./styles/pages/home/difference_menutabs_bottom.scss";
import "./styles/pages/home/difference_comments.scss";
import "./styles/pages/home/insights.scss";
import "./styles/pages/home/case_study.scss";
import "./styles/pages/home/mobile_cards.scss";
import "./styles/pages/home/slider.scss";
import "./styles/pages/solutions/solutions.scss";
import "./styles/pages/solutions/more-info.scss";
import "./styles/pages/solutions/valuablesgood.scss";
import "./styles/pages/solutions/loomis_pay.scss";
import "./styles/pages/solutions/cash_24_7.scss";
import "./styles/pages/loomis_difference/content_pages_diff.scss";
import "./styles/pages/aboutus/related_studies_case.scss";
import "./styles/pages/aboutus/new_press_release.scss";
import "./styles/pages/aboutus/news.scss";
import "./styles/pages/aboutus/insights.scss";
import "./styles/pages/aboutus/our_history.scss";
import "./styles/pages/aboutus/our_values.scss";
import "./styles/pages/sectorial_solutions/financial_companies.scss";
import "./styles/pages/sectorial_solutions/mobile_cards_sectorial.scss";
import "./styles/pages/careers/careers.scss";
import "./styles/pages/careers/mobile_cards_careers.scss";
import "./styles/pages/support/new_customers.scss";
import "./styles/pages/support/support.scss";
import "./styles/pages/support/faqs.scss";
import "./styles/pages/support/locations.scss";
import "./styles/pages/search_results/search_results.scss";
import "./styles/pages/aboutus/single_case_studies.scss";